import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import {
    ApprovalState,
    ThirdPartyPayoff,
} from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface SetThirdPartyPayoffApprovalRequest {
    engagementId: number;
    tableRowId: number;
    targetState: ApprovalState;
}

export const SetThirdPartyPayoffApproval = createAsyncThunk(
    'flowOfFunds/setThirdPartyPayoffApproval',
    async (params: SetThirdPartyPayoffApprovalRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}/approval`,
                {
                    targetState: params.targetState,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to save the approval');
            }

            return response.data as ThirdPartyPayoff;
        } catch (error) {
            createNotification('Could not save the approval.', 'error');
            throw error;
        }
    }
);
